export default __webpack_public_path__ + "static/media/glowbaccart_pannel.f87899d6.png";